import { createSvgComponent } from "../../icon/createSvgComponent";
import Grid from "@core/__generated__/icon/figma/grid.svg";
export default createSvgComponent(Grid);